<template>
  <div class="on-live" @click="handle2Active">
    <img :src="$isCdn(online.img_url)" alt="" />
    <div class="live-info">
      <div class="title van-ellipsis">{{ online.event_name }}</div>
      <div class="time">
        <span>{{ online.start_time }}</span>
        <span>{{ online.look }}观看</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['online'],
  methods: {
    handle2Active() {
      this.$router.push(`/play/${this.online.event_info_id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.on-live {
  width: 164px;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 14px;
  img {
    width: 100%;
    height: 92px;
  }
  .live-info {
    padding: 6px;
    .title {
      color: #303133;
      font-weight: 500;
      font-size: 14px;
      line-height: 2;
    }
    .time {
      color: #909399;
      font-size: 12px;
    }
    .time span:nth-child(2) {
      margin-left: 10px;
    }
  }
}
</style>
